import {  Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[focusFirstInvalidField]'
})
export class FocusFirstInvalidFieldDirective {

  constructor(private el: ElementRef) { }
  @HostListener('ngSubmit')
  onFormSubmit() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.ng-invalid');

    if (invalidElements.length >0) {
      if(invalidElements[0].localName != "mat-radio-group"){
        invalidElements[1].focus(); 
      }else{        
        invalidElements[0].scrollIntoView({ behavior: 'smooth', block: 'center' });       
      }       
    }
  }

}
